<section
  [class.reverse]="props?.style?.button?.iconPosition === 'right'"
  [ngStyle]="sectionStyles()"
  class="recorder"
>
  <!-- Record button -->
  <button
    (click)="emitClick()"
    (contextmenu)="$event.preventDefault()"
    (mousedown)="onMouseDownStartRecording($event)"
    (touchstart)="onMouseDownStartRecording($event)"
    [attr.data-cy]="'AudioRecorder:recordButton_' + recordMode()"
    [disabled]="isLoaderVisible() || isAudioStreamInitializing()"
    [ngStyle]="buttonStyles()"
    class="record"
  >
    <div class="shade"></div>
    @if (isLoaderVisible()) {
      <blaze-element-loading-indicator [isVisible]="true" mode="white" />
    } @else {
      @if (buttonIcon()) {
        <mat-icon [svgIcon]="buttonIcon()" />
      }
    }
  </button>

  @if (buttonLabel()) {
    <div class="label-section">
      <div class="label-and-timer">
        <blaze-element-label
          [color]="labelStyles().color"
          [extendInputPadding]="elementContext?.extendInputPadding"
          [fontFamily]="labelStyles().fontFamily"
          [fontSize]="labelStyles().fontSize"
          [fontStyle]="labelStyles().fontStyle"
          [fontWeight]="labelStyles().fontWeight"
          [horizontalAlign]="props?.content?.title?.align"
          [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
          data-cy="AudioRecorder:buttonLabel"
        >
          {{ buttonLabel() }}
        </blaze-element-label>

        @if (isRecording()) {
          <div
            [ngStyle]="recordTimeStyles()"
            class="record-time"
            data-cy="AudioRecorder:recordingTime"
          >
            {{ recordTime() }}
          </div>
        }
      </div>

      @if (isRecording() && recordMode() === 'click') {
        <button
          (click)="onCancelRecording()"
          class="bd-btn-icon-flat"
          data-cy="AudioRecorder:cancelRecording"
          title="Cancel recording"
        >
          <mat-icon class="text-primary-darker" svgIcon="icon_close_16" />
        </button>
      }
    </div>
  }
</section>
